import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";

import {inject} from "../../services/di";
import {CouponService} from "../../services/CouponService";
import {ClippingService, ClippingPrintItemAdapter} from "../../services/ClippingService";
import {EventService} from "../../services/EventService";
import {Coupon} from "../../definitions/CouponDefinitions";
import {ClippingType} from "../../definitions/CommonDefinitions";

interface ClipCouponButtonAttributes extends JSX.HTMLProps {
	couponId: number;
}

@element("flipp-clip-coupon", "button")
export class ClipCouponButton extends Component<ClipCouponButtonAttributes, Coupon> {
	@attr couponId: number;
	@inject clippings: ClippingService;
	@inject couponService: CouponService;
	@inject eventService: EventService;

	onAttach() {
		this.addEventListener("click", this._handleClick);
	}

	onDetach() {
		this.removeEventListener("click", this._handleClick);
	}

	prepare() {
		return this.couponService.getCoupon(this.couponId);
	}

	render(coupon: Coupon) {
		const isClipped = this.clippings.hasClipping(`${coupon.id}`);

		return <span>
			{isClipped ? i18n("remove_clip_button") : i18n("add_clip_button")}
		</span>;
	}

	private _handleClick = (e: Event) => {
		const coupon = this.model;

		const added = this.clippings.toggleClipping(ClippingType.PRINT_COUPON,
			new ClippingPrintItemAdapter(coupon), i18n("print_coupons"));
		this.eventService.fireCouponClippedEvent(this.couponId, "clip-button", added ? "added" : "removed", this);

		this.invalidate();
	}
}
